import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const SuccessPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // 🔄 Marca para que Index.jsx refresque plan al volver del pago
    localStorage.setItem("refresh_after_payment", "true");
  }, []);

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 py-8 px-4 text-white flex items-center justify-center">
      <div className="max-w-2xl mx-auto text-center">
        <div className="bg-gray-900/80 backdrop-blur-sm border border-green-500 rounded-2xl shadow-lg hover:shadow-green-500/50 p-12">
          <div className="flex flex-col items-center space-y-6">
            <svg
              className="w-24 h-24 text-green-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            <h1 className="text-5xl font-extrabold text-green-400 mb-4">
              ✅ Payment Successful!
            </h1>
            <p className="text-xl text-gray-300 mb-8 max-w-md mx-auto">
              Your plan is now active. You can start summarizing documents again.
            </p>
            <button
              onClick={() => {
                localStorage.setItem("refresh_after_payment", "true");
                window.location.href = "/";    // 🔥 Forza remount total
              }}
              className="px-8 py-4 bg-green-600 hover:bg-green-700 text-white font-semibold text-lg rounded-xl shadow-lg transition-all transform hover:scale-105"
            >
              Go Back to Agent
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPage;

